import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { HeroSection } from './components/HeroSection';
import { StorySection } from './components/StorySection';
import { TruthSection } from './components/TruthSection';
import { ProductRevealSection } from './components/ProductRevealSection';
import { TransformationSection } from './components/TransformationSection';
import { MoneySection } from './components/MoneySection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-cream font-sans selection:bg-terracotta/30" data-id="element-0">
      <StickyCTA data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <StorySection data-id="element-4" />
        <TruthSection data-id="element-5" />
        <ProductRevealSection data-id="element-6" />
        <TransformationSection data-id="element-7" />
        <MoneySection data-id="element-8" />
        <FAQSection data-id="element-9" />
        <FinalCTASection data-id="element-10" />
      </main>

      <Footer data-id="element-11" />

      <SocialProofPopup data-id="element-12" />
    </div>;
}